import { API_TRAVEL_APARTMENT_INIT, API_TRAVEL_INIT } from '../consts/endpoints'
import { csrfJsonFetch } from '../../functions/csrfFetch'

export const fetchPossibleParams = async (transport) => {
    const response = await csrfJsonFetch(API_TRAVEL_INIT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({transport})
    })

    const dataResponse = await response.json();

    if (!response.ok) {
        throw new Error(dataResponse.message);
    }

    return dataResponse;
}
export const fetchApartmentPossibleParams = async (transport) => {
    const response = await csrfJsonFetch(API_TRAVEL_APARTMENT_INIT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({})
    })

    const dataResponse = await response.json();

    if (!response.ok) {
        throw new Error(dataResponse.message);
    }

    return dataResponse;
}
